/**
 * Module dependencies.
 */

import { ListFilters } from 'app/components/organisms/crud/form-filters/form-filters-type';
import { CrudListType, CrudTemplate, ListColumns } from 'app/components/organisms/crud/form-types';
import { normalizeTemplate } from 'app/components/organisms/crud/utils';
import { appRoutes } from 'app/routes';
import { TFunction } from 'i18next';
import { Alarm, DeviceAlarm } from 'app/types/medication';
import React from 'react';
import { DateTime } from 'app/components/atoms/date-time/date-time';

/**
 * List labels.
 */

const listColumns = (translate: TFunction): ListColumns<Alarm> => [
  {
    title: translate('common.table.columns.id'),
    dataIndex: 'id',
    key: 'id',
    render: (item: Alarm) => `${item.id.slice(0, 4)}...${item.id.slice(-4)}` // Exibe primeiros e últimos 4 caracteres
  },
  {
    title: translate('common.table.columns.consumed'),
    dataIndex: 'consumed',
    key: 'consumed',
    render: (item: Alarm) => String(item.consumed ? 'YES' : 'NO')
  },
  {
    title: translate('common.table.columns.fireDate'),
    dataIndex: 'fireDate',
    key: 'fireDate',
    render: (item: Alarm) => <DateTime date={item.fireDate} />
  },
  {
    title: translate('common.table.columns.consumedDeviceId'),
    dataIndex: 'consumedDeviceId',
    key: 'consumedDeviceId',
    render: (item: Alarm) =>
      item.consumedDeviceId ? `${item.consumedDeviceId.slice(0, 4)}...${item.consumedDeviceId.slice(-4)}` : 'N/A'
  },
  {
    title: translate('common.table.columns.consumedAt'),
    dataIndex: 'consumedAt',
    key: 'consumedAt',
    render: (item: Alarm) => <DateTime date={item.consumedAt} />
  },
  {
    title: translate('common.table.columns.consumedSnoozeFireDate'),
    dataIndex: 'consumedSnoozeFireDate',
    key: 'consumedSnoozeFireDate',
    render: (item: Alarm) => <DateTime date={item.consumedSnoozeFireDate} />
  },
  {
    title: translate('common.table.columns.createdAt'),
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: (item: Alarm) => <DateTime date={item.createdAt} />
  },
  {
    title: translate('common.table.columns.updatedAt'),
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: (item: Alarm) => <DateTime date={item.updatedAt} />
  }
];

/**
 * List filters.
 */

const listFilters = (translate: TFunction): ListFilters => [
  {
    type: 'inputSearch',
    inline: true,
    name: 'search',
    label: String(translate('common.labels.search'))
  }
];

/**
 * List.
 */

const list = (translate: TFunction, extendedProposalsTemplate: CrudTemplate<DeviceAlarm>): CrudListType<Alarm> => ({
  addButton: undefined,
  columns: listColumns(translate),
  expandedTemplate: extendedProposalsTemplate as any,
  canEdit: false,
  canRemove: false,
  style: { minWidth: 500, maxWidth: '100%' },
  nestedList: item => {
    return item.alarms;
  },
  route: appRoutes.dashboard.users.detail.medications,
  key: ['medicationsAlarms'],
  endpoint: null,
  filters: listFilters(translate)
});

/**
 * Config.
 */

export function createExtendedAlarmsTemplate(
  translate: TFunction,
  extendedProposalsTemplate: CrudTemplate<DeviceAlarm>
): CrudTemplate<Alarm> {
  return normalizeTemplate(translate, {
    list: list(translate, extendedProposalsTemplate)
  });
}
